 /*
  * Lightbox gallery
  */

 $('.block-gallery').lightGallery({
     selector: '.post-gallery-item',
     share: true,
     download: true,
     rotate: false,
     showThumbByDefault: true,
     loop: false,
     slideEndAnimatoin: false,
     thumbnail: true,
     allowMediaOverlap: true,
     toggleThumb: true,
     youtubePlayerParams: {
         loadYoutubeThumbnail: true,
         youtubeThumbSize: 'default',
         modestbranding: 1,
         showinfo: 0,
         rel: 0
     }
 });

 /*
  * Owl carousel
  */

 $('.owl-block').owlCarousel({
     margin: 20,
     items: 1,
     loop: true,
     autoplay: true,
     autoplayTimeout: 4500,
     nav: true,
     dots: true,
     navText: ["<i class='icon-angle-left'></i>", "<i class='icon-angle-right'></i>"],
     // navContainer: '#customNav', 
     responsive: {
        0: {
            items: 1
        },
        700: {
            items: 2,
            margin: 0,
        },
        1200: {
            items: 4,
        }
    }
 });


 $('.owl-logos').owlCarousel({
     margin: 20,
     items: 4,
     loop: true,
     autoplay: true,
     autoplayTimeout: 4500,
     nav: true,
     dots: true,
     navText: ["<i class='icon-angle-left'></i>", "<i class='icon-angle-right'></i>"],
     // navContainer: '#customNav', 
     responsive: {
         0: {
             items: 1
         },
         700: {
             items: 2,
             margin: 0,
         },
         1200: {
             items: 4,
         }
     }
 });

function syncMobileLogoSliders() {
    $('.logos-grid-mobile-slider').each(function () {
        var $slider = $(this);
        var isMobile = window.matchMedia('(max-width: 767px)').matches;

        if (isMobile && !$slider.hasClass('owl-loaded')) {
            $slider
                .addClass('owl-carousel owl-theme')
                .owlCarousel({
                    items: 2,
                    margin: 16,
                    stagePadding: 8,
                    loop: true,
                    autoplay: true,
                    autoplayTimeout: 3000,
                    autoplayHoverPause: true,
                    smartSpeed: 600,
                    touchDrag: true,
                    mouseDrag: true,
                    nav: false,
                    dots: true
                });
        } else if (!isMobile && $slider.hasClass('owl-loaded')) {
            $slider.trigger('destroy.owl.carousel');
            $slider
                .removeClass('owl-carousel owl-theme owl-loaded owl-hidden')
                .removeAttr('style');
        }
    });
}

syncMobileLogoSliders();

var mobileLogoSliderResizeTimer;

$(window).on('resize', function () {
    window.clearTimeout(mobileLogoSliderResizeTimer);
    mobileLogoSliderResizeTimer = window.setTimeout(syncMobileLogoSliders, 150);
});

$('.single-study-program__events-carousel').each(function () {
    var $carousel = $(this);
    var $navTarget = $carousel
        .closest('.single-study-program__section')
        .find('.single-study-program__events-nav');

    $carousel.owlCarousel({
        margin: 24,
        items: 3.3,
        loop: true,
        autoplay: true,
        nav: true,
        dots: false,
        navText: ["<i class='icon-angle-left'></i>", "<i class='icon-angle-right'></i>"],
        navContainer: $navTarget,
        responsive: {
            0: {
                items: 1
            },
            768: {
                items: 2
            },
            1200: {
                items: 3.3
            }
        }
    });
});
